import {Directive, ElementRef, SimpleChange, OnInit} from '@angular/core';
import {NgControl} from '@angular/forms';
import {NumeralService} from '../services/Numeral.service';
declare var jQuery: any;
@Directive({
    selector: '[model-numeral]',
    standalone: true,
    host: {
        '(blur)': 'onBlur($event)',
        '(focus)': 'onFocus($event)',
        '(keyup)': 'onKeyUp($event)'
    },
    inputs: ['locale', 'format', 'unsigned', 'isNumber']
})

export class ModelBasedNumeral implements OnInit{
  public hasInitialized: boolean;
  public locale: string;
  public format: string;
  public unsigned: boolean;
  public input: any;
  public isNumber: boolean;

  constructor(public model: NgControl, private el: ElementRef, private numeralService: NumeralService) {
      this.input = jQuery(this.el.nativeElement);
  }

  ngOnInit() {
      this.onBlur();
      this.model['update'].subscribe(value =>{

          if (!jQuery(this.input).is(':focus')){
              if (this.isNumber){
                  this.model.valueAccessor.writeValue(this.numeralService.formatNumber(this.format, this.input.val()));
              }else{
                  this.model.valueAccessor.writeValue(this.numeralService.format(this.format, this.input.val()));
              }

          }
      });
  }

  private onBlur(e?: any) {
      const base = this;
      this.switchLocale();
      let value: any;
      if (this.isNumber){
          value = this.numeralService.getNumberValue(this.input.val());
      }else {
          value = this.numeralService.value(this.input.val());
      }
      if (!value) {
          if (this.isNumber){
              value = this.numeralService.getNumberValue(this.model['model']);
          }else {
              value = this.numeralService.value(this.model['model']);
          }

      }
      if (value) {
          let formatVal: any;
          if (this.isNumber){
              formatVal = this.numeralService.formatNumber(this.format, value);
          }else {
              formatVal = this.numeralService.format(this.format, value);
          }
          this.model.viewToModelUpdate(value);
          this.model.control.setValue(value);
          setTimeout(function() {
              base.model.valueAccessor.writeValue(formatVal);
          }, 50);
      } else if (value == 0){
          const formatVal = this.numeralService.format(this.format, value);
          this.model.viewToModelUpdate(value);
          this.model.control.setValue(value);
          setTimeout(function() {
              base.model.valueAccessor.writeValue(formatVal);
          }, 50);
      }
  }

  private onKeyUp($event) {
      if (this.unsigned && $event.keyCode == 189) {
          let value = this.input.val();
          value = value.replace(/-/g, '');
          this.input.val(value);
      }
  }

  private onFocus(e: any) {
      if (this.isNumber){
          this.model.valueAccessor.writeValue(this.numeralService.getNumberValue(this.input.val()));
      }else {
          this.model.valueAccessor.writeValue(this.numeralService.value(this.input.val()));
      }

      /*let value = this.numeralService.value(this.input.val());
      if(value == 0){
          this.model.valueAccessor.writeValue('');
      } else{
          this.model.valueAccessor.writeValue(value);
      }*/
  }

  switchLocale() {
      this.numeralService.switchLocale(this.locale);
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
      if (this.hasInitialized && (changes['locale'])) {
          this.switchLocale();
      }
  }

  ngOnDestroy() {

  }
}
